<template>
    <div class="w-full">
        <div v-if="!show" class="m-l-34  m-t-20 ">
            <div class="watting-dot"></div>
        </div>
        <div class="p-0-14" v-if="show">
            <!-- 已完成标志 -->
            <div class="flex-center content_top m-b-28">
                <div v-if="order.status === 'success'" class="flex-center w-full p-24-32">
                    <div class="m-b-24">
                        <el-icon :size="78" color="#52C41A">
                            <SuccessFilled />
                        </el-icon>
                    </div>
                    <div class="title14">{{ $t('orders.completed') }}</div>
                    <div class="title13">{{ $t('subscription.hans_sucess') }}</div>
                    <div class="m-t-32" v-if="!store.state.isMobile">
                        <el-button type="danger" round @click="jumpToDocument()">{{ $t('subscription.view_tutorial')
                        }}</el-button>
                    </div>
                </div>
                <div v-if="order.status === 'timeout'">
                    <div class="p-20-20-24  flex-center">
                        <img style="width:78px" src="../../assets/img/warning.png" alt="">
                    </div>
                    <div class="p-12-20 flex-center title14">
                        {{ $t('subscription.order_timeout') }}
                    </div>
                </div>
                <div v-if="order.status === 'cancel' || order.status === 'close'">
                    <div class="p-20-20-24  flex-center">
                        <img style="width:78px" src="../../assets/img/warning.png" alt="">
                    </div>
                    <div class="p-12-20 flex-center title14">
                        {{ $t('subscription.order_canceled') }}
                    </div>
                </div>
                <div v-if="order.status === 'failed'">
                    <div class="p-20-20-24  flex-center">
                        <el-icon :size="78" color="#f65a5a">
                            <CircleCloseFilled />
                        </el-icon>
                    </div>
                    <div class="p-12-20 flex-center title14">
                        {{ $t('subscription.order_payment_failed') }}
                    </div>
                </div>
                <div v-if="order.status === 'unused'">
                    <div class="p-20-20-24  flex-center">
                        <el-icon :size="78" color="#f65a5a">
                            <QuestionFilled />
                        </el-icon>
                    </div>
                    <div class="p-12-20 flex-center title14">
                        {{ $t('subscription.order_status_unknown') }}
                    </div>
                </div>
                <div v-if="order.status === 'rejected'">
                    <div class="p-20-20-24  flex-center">
                        <el-icon :size="78" color="#f65a5a">
                            <CircleCloseFilled />
                        </el-icon>
                    </div>
                    <div class="p-12-20 flex-center title14">
                        {{ $t('subscription.order_chargeback') }}
                    </div>
                </div>
                <div v-if="order.status === 'doing'">
                    <div class="p-20-20-24  flex-center">
                        <img style="width:78px" src="../../assets/img/doing.png" alt="">
                    </div>
                    <div class="p-12-20 flex-center title14">
                        {{ $t('subscription.order_in_process') }}
                    </div>
                </div>
                <div v-if="order.status === 'paying' || order.status === 'waiting'">
                    <div class="p-20-20-24  flex-center">
                        <img style="width:78px" src="../../assets/img/doing.png" alt="">
                    </div>
                    <div class="p-12-20 flex-center title14">
                        <!-- {{ $t('subscription.order_in_process') }} -->
                        {{ $t('prompt.paying') }}
                    </div>
                </div>
                <div class="p-20-20-24  flex-center" v-if="order.status === 'refunded'">
                    <div>
                        <el-icon :size="78" color="#52C41A">
                            <SuccessFilled />
                        </el-icon>
                    </div>
                    <div class="p-12-20 flex-center title14">
                        {{ $t('subscription.order_has_been_refunded') }}
                    </div>
                </div>
            </div>
            <!-- 商品信息 -->
            <div class="content_top m-b-28">
                <div class="p-20-20-24 bg-f8f9fc">
                    <span class="title1 ">{{ $t('subscription.commodity_information') }}</span>
                </div>
                <div class="p-12-20">
                    <div class="flex m-b-5">
                        <div class="flex-1-1 title5">{{ $t('subscription.product_name') }}:</div>
                        <div class="flex-2-1">
                            {{ order.pdName }}
                        </div>
                    </div>
                    <div class="flex m-b-5">
                        <div class="flex-1-1 title5">{{ $t('subscription.type') }}:</div>
                        <div class="flex-2-1" >
                            {{ order.pkgType }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 订单信息 -->
            <div class="content_top m-b-28">
                <div class="p-20-20-24 bg-f8f9fc">
                    <span class="title1 ">{{ $t('subscription.order_information') }}</span>
                </div>
                <div class="p-12-20">
                    <div class="flex m-b-5">
                        <div class="flex-1-1 title5">{{ $t('subscription.order_number') }}:</div>
                        <div class="flex-2-1">{{ order.no }}</div>
                    </div>
                    <div class="flex m-b-5">
                        <div class="flex-1-1 title5">{{ $t('subscription.creation_time') }}:</div>
                        <div class="flex-2-1">{{ changeTime(order.createAt) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ordersApi } from '@/utils/api';
import { useI18n } from 'vue-i18n'
import { ElNotification } from 'element-plus'
import { timeFilter } from '@/utils/tool';
import { useStore } from 'vuex';
import {
    SuccessFilled,
    CircleCloseFilled,
    QuestionFilled
} from '@element-plus/icons-vue'
export default {
    components: { SuccessFilled, CircleCloseFilled, QuestionFilled },
    setup() {
        const { t } = useI18n()
        const store = useStore();
        return { t, store }
    },
    data() {
        return {
            order: {},
            timer: null, //定时器名称
            show: false,
        }
    },
    methods: {
        getOrder(no) {
            let param = {
                no: no
            };
            ordersApi(param).then(res => {
                if (res !== undefined) {
                    if (res.data.code === 0) {
                        if (res.data.data.length !== 0) {
                            this.show = true
                            this.order = res.data.data[0];
                            if (this.order.status === 'success' || this.order.status === 'timeout' || this.order.status === 'refunded' || this.order.status === 'cancel' || this.order.status === 'close' || this.order.status === 'failed') {
                                if (this.timer !== null) {
                                    clearInterval(this.timer);// 清除定时器
                                    this.timer = null;
                                }
                            }
                        }
                    } else {
                        return ElNotification({
                            title: this.t('prompt.Mistake'),
                            message: res.data.msg,
                            type: 'error',
                            duration: 2500
                        })
                    }
                } else {
                    return ElNotification({
                        title: 'Error',
                        message: 'Network error',
                        type: 'error',
                        duration: 2500
                    })
                }
            })
        },

        //定时器
        setTime(no) {
            //每隔一分钟运行一次保存方法
            this.timer = setInterval(() => {
                this.getOrder(no);
            }, 10000)
        },
        jumpToDocument() {
            this.store.commit('updateActiveName', 'aside.knowledge_base');
            this.store.commit('updateActivePath', '/document');
            this.$router.push('/document');
        },
        //转换
        changeTime(time) {
            return timeFilter(time);
        }
    },
    created() {
        let no = this.$route.params.params;
        this.store.commit('updateActiveName', 'aside.order_details');
        this.store.commit('updateActivePath', '/status');
        this.getOrder(no);
        this.setTime(no);
    },
    beforeUnmount() {
        if (this.timer !== null) {
            clearInterval(this.timer);// 清除定时器
            this.timer = null;
        }
    },
    watch:{
        "$i18n.locale"() {
            let no = this.$route.params.params;
            this.getOrder(no);
        },
    }
}
</script>